export const DateNumberValidator = (inputNumberDate: number): boolean => {
	let actualDate = new Date();
	let stringDate = inputNumberDate.toString();
	let divisor = inputNumberDate > 99999 ? 2 : 1;

	let month = stringDate.substring(0, divisor);
	let year = stringDate.substring(divisor);
	if (parseInt(month) > 12 || parseInt(year) < 1920) return false;

	const inputDate = new Date(parseInt(year), parseInt(month) - 1);

	return inputNumberDate > 9999 && actualDate.getTime() > inputDate.getTime();
};

export const DateStringValidator = (inputNumberDate: string): boolean => {
	let actualDate = new Date();
	let stringDate = inputNumberDate.toString();

	let month = parseInt(stringDate.substring(0, 2));
	let year = parseInt(stringDate.substring(2));

	if (month > 12 || month < 1 || year < 1920) return false;

	const inputDate = new Date(year, month - 1);

	return actualDate.getTime() > inputDate.getTime();
};
